import React, { useContext, useEffect, useState } from 'react'
import { DatePicker, Form, Input, Select, Switch, Tag } from 'antd'
import GlobalContext from '../GlobalContext'
import { t } from 'i18next'
import TextArea from 'antd/es/input/TextArea'
import { get } from '../../Common/api'
import { displayHierarchy } from '../../Common/Common'
import EventInChargeSelect from './EventInChargeSelect'

export default function EventForm ({ form, onFinish, slotId, boxId }) {
  const { data } = useContext(GlobalContext)
  const [level2Ticket, setLevel2Ticket] = useState(false)
  const [tags, setTags] = useState([])
  const [selectedTags, setSelectedTags] = useState([])
  const [inCharge, setInCharge] = useState()

  useEffect(() => {
    getTags()
    getInCharge()
  }, [])

  const getTags = async () => {
    await get({
      url: 'admin/tags',
      params: {},
      onSuccess: (json) => {
        const sortedTags = json.tags.map((tag) => ({ ...tag, value: tag.id, label: t(`Admin.Tag.${tag.name}`) })).sort((a, b) => a.label.localeCompare(b.label))
        setTags(sortedTags)
      }
    })
  }

  const getInCharge = async () => {
    await get({
      url: 'admin/events/in_charge_options',
      params: {},
      onSuccess: (res) => {
        setInCharge(res)
      }
    })
  }

  const initialValues = {
    slot_id: slotId,
    box_id: boxId,
    created_by_id: data.user.id,
    in_charge: 'vig_1'
  }

  const updateSelectedTags = (values) => {
    setSelectedTags(tags.filter((tag) => values.includes(tag.id)))
  }

  const removeSelectedTags = (value) => {
    setSelectedTags(selectedTags.filter((tag) => value !== tag.id))
  }

  const tagRender = props => {
    const { label, value, closable, onClose } = props
    const tag = tags.find((e) => e.id === value)
    const onPreventMouseDown = event => {
      event.preventDefault()
      event.stopPropagation()
    }
    return (<Tag
      color={tag?.color}
      onMouseDown={onPreventMouseDown}
      closable={closable}
      onClose={onClose}
      style={{ marginInlineEnd: 4 }}
      variant='solid'
    >
      {label}
    </Tag>
    )
  }

  return (
    <Form
      id="EventFormAdmin"
      form={form}
      onFinish={onFinish}
      initialValues={initialValues}
      size='small'
    >
      <Form.Item name='slot_id' hidden>
        <Input />
      </Form.Item>
      <Form.Item name='box_id' hidden>
        <Input />
      </Form.Item>
      <Form.Item name='created_by_id' hidden>
        <Input />
      </Form.Item>
      <Form.Item name='title' label={t('Admin.Event.attributes.title')}
        rules={[{ required: true, message: t('rules.required') }]}>
        <Input />
      </Form.Item>
      <Form.Item name='content' label={t('Admin.Event.attributes.content')}
        rules={[{ required: true, message: t('rules.required') }]}>
        <TextArea />
      </Form.Item>
      <Form.Item name="in_charge" label={t('Admin.Event.attributes.inCharge')}
        rules={[{ required: true, message: t('rules.required') }]}>
        <EventInChargeSelect inCharge={inCharge} onChange={(v) => form.setFieldValue('in_charge', v)}/>
      </Form.Item>
      <div style={{ marginBottom: '1em' }}>
        <div>{t('Admin.Event.businessArea')}</div>
        <div>
          {displayHierarchy(selectedTags)}
        </div>
      </div>
      <Form.Item name='tag_ids' label={t('Admin.Event.attributes.tags')}
        rules={[{ required: true, message: t('rules.required') }]}>
        <Select
          mode="multiple"
          tagRender={tagRender}
          allowClear
          style={{ width: '80%' }}
          placeholder="Choississez un Tag"
          options={tags}
          showSearch={{
            filterOption: (input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
          }}
          onChange={updateSelectedTags}
          onDeselect={removeSelectedTags}
          defaultValue={tags.map((tag) => tag.id)}
        />
      </Form.Item>
      <Form.Item name='notify_level_2' label={t('Admin.Event.attributes.level2Ticket')}>
        <Switch onChange={(value) => setLevel2Ticket(value)} />
      </Form.Item>
      {level2Ticket &&
        <Form.Item name='date' label={t('Admin.EventList.table.level2.date')}>
          <DatePicker showTime={{ format: 'HH:mm' }} format="DD/MM/YYYY HH:mm" />
        </Form.Item>
      }
    </Form>
  )
}
